export default __webpack_public_path__ + "static/media/3.blur.f760b0f8.jpg";